/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { strings } from '../../../../intl/Strings';
import { logger } from '../../../../shared';
import { LftCountdownAction, LftCountdownActionId, getIconForActionId } from '../shared';

export const LftCountdownResearcherActionCard: LftCountdownAction = {
    id: LftCountdownActionId.ResearcherDialog,
    primaryContent: strings.getString('lftSidePaneTrialCountDownResearchCardText'),
    icon: getIconForActionId(LftCountdownActionId.ResearcherDialog),
    onClick: () => logger.logInfo('LaunchResearcherDialog', 'User clicked on researcher card.')
};
